import { createContext, useContext, useState } from "react";
import Slideout from "../components/Slideout";

const SlideoutContext = createContext();

export const SlideoutProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [slideoutData, setSlideoutData] = useState({ title: "", content: null });

  const openSlideout = ({ title, content }) => {
    setSlideoutData({ title, content });
    setIsOpen(true);
    setIsExpanded(false);
  };

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const closeSlideout = () => {
    setIsOpen(false);
    setTimeout(() => setSlideoutData({ title: "", content: null }), 300); // Wait for animation
  };

  return (
    <SlideoutContext.Provider value={{ openSlideout, closeSlideout, toggleExpanded, isExpanded }}>
      {children}
      <Slideout isOpen={isOpen} isExpanded={isExpanded} onClose={closeSlideout} {...slideoutData} />
    </SlideoutContext.Provider>
  );
};

export const useSlideout = () => useContext(SlideoutContext);
